import service from './ResetPasswordService';
import customerService from '../customer/CustomerService';
import {
  PASSWORD_GET_REQUEST,
  PASSWORD_GET_SUCCESS,
  PASSWORD_GET_FAILURE,
} from './ResetPasswordActionType';

export const resetPassword = (userName, newPassword) => async () => {
  try {
    const passwordPromise = service.post({
      userName,
      password: newPassword,
    });

    const customerPromise = customerService.updateName();

    await Promise.all([passwordPromise, customerPromise]);

    return true;
  } catch (e) {
    return false;
  }
};

export const loadCurrentPassword = () => async (dispatch) => {
  dispatch({ type: PASSWORD_GET_REQUEST });
  try {
    const userInfo = await service.search();
    dispatch({ type: PASSWORD_GET_SUCCESS, payload: userInfo.data });
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e);
    dispatch({ type: PASSWORD_GET_FAILURE });
  }
};
